import { Rarity } from '#src/__generated__/globalTypes.ts';
import { useSeriesNav } from '#src/hooks/commonGame/useSeriesNav.ts';
import { LIFECYCLE, useLifecycle } from '#src/hooks/useLifecycle.ts';
import { isRarityStr } from '#src/lib/so5.ts';
import { useCommonGameSet } from '#src/set/index.ts';

export const usePinnedShardRarity = () => {
  const commonGameSet = useCommonGameSet();
  const seriesNav = useSeriesNav();
  const { lifecycle, update: updateLifecycle } = useLifecycle();
  const [rarity] =
    typeof lifecycle?.pinnedShardRarity === 'string'
      ? lifecycle.pinnedShardRarity.split(':')
      : [];

  // force pinned rarity to active Set card set if series nav is active
  const finalRarity = (() => {
    if (seriesNav) {
      return Rarity.common;
    }
    if (rarity === Rarity.common) {
      return undefined;
    }
    return rarity;
  })();
  const finalCardSet = seriesNav ? commonGameSet.slug : undefined;

  return {
    pinnedShardRarity: isRarityStr(finalRarity) ? finalRarity : undefined,
    pinnedShardCardSet: finalCardSet,
    updatePinnedShardRarity: (
      inputRarity: Rarity,
      inputCardSet: Nullable<string>
    ) => {
      const value = inputCardSet
        ? `${inputRarity}:${inputCardSet}`
        : inputRarity;
      updateLifecycle(
        LIFECYCLE.pinnedShardRarity,
        lifecycle?.[LIFECYCLE.pinnedShardRarity] === value ? false : value
      );
    },
  };
};
